module.exports = __webpack_public_path__ + "img/bread-easypay-deliver.33cd7764.png";